export const DOCUMENT_VIEWER_MODES = {
  LIST: "list",
  STAGED: "staged",
  SELECT: "select",
  ESIGNING: "esigning"
};
